// Resumen de una clase, hecho con IA a partir del video (subtítulos de Vimeo) y los PDFs de la clase.
// Lo escribe la automatización en la API (PUT classes/:id/summary) y el front lo lee con
// GET courses/:cid/class/:sid/summary. En los textos, **así** se muestra en negrita.

export interface ClassSummaryTable {
  columns: string[];
  rows: string[][];
}

/** Barras horizontales agrupadas: cada grupo tiene un valor por serie, todos >= 0 y <= max. */
export interface ClassSummaryChart {
  title: string;
  unit?: string;
  max: number;
  series: string[];
  groups: { label: string; values: number[] }[];
  note?: string;
}

export interface ClassSummarySection {
  title: string;
  /** Segundo del video donde se explica (para saltar ahí). */
  seconds?: number | null;
  /** Id de Vimeo del video al que se refiere `seconds`, si la clase tiene más de uno. */
  video?: string | null;
  paragraphs?: string[];
  bullets?: string[];
  highlight?: string | null;
  table?: ClassSummaryTable | null;
  chart?: ClassSummaryChart | null;
}

export interface ClassSummary {
  version: number;
  title: string;
  idea: string;
  readingMinutes: number;
  sections: ClassSummarySection[];
  task?: string | null;
  source?: string | null;
}

export const parseClassSummary = (raw?: string | null): ClassSummary | null => {
  if (!raw) {
    return null;
  }
  try {
    const summary = JSON.parse(raw) as ClassSummary;
    return summary?.title && Array.isArray(summary.sections) && summary.sections.length ? summary : null;
  } catch {
    return null;
  }
};
